<glxy-uploader-list
  *ngIf="fileTypes() === 'other'"
  class="upload-file-list"
  [files]="files()"
  (fileDeleted)="removeFile()"
  [ngClass]="{ empty: files().length === 0 }"
></glxy-uploader-list>
<glxy-image-list
  *ngIf="fileTypes() === 'image'"
  class="upload-file-list"
  [files]="files()"
  (delete)="removeFile()"
  [ngClass]="{ empty: files().length === 0 }"
></glxy-image-list>

<!--CV Insert Review Link-->
<inbox-insert-review-link #inboxInsertReviewLink (insertLink)="insertLink($event)"></inbox-insert-review-link>
<!--Partner to Create Payment Link-->
<inbox-insert-payment-link
  #inboxInsertPaymentLink
  [conversationDetail]="conversationDetail$ | async"
  (insertLink)="insertLink($event)"
></inbox-insert-payment-link>

@if ($isAIResponderActiveForConversation()) {
  @let assistant = $conversationAIResponder()?.assistant;
  @let aiResponseWaiting = isAIWaitingToReply() > 0;
  <div class="ai-responder-container">
    <div class="ai-responder-assistant-info">
      @if (assistant) {
        <glxy-avatar
          class="avatar"
          [width]="30"
          [svgIcon]="DEFAULT_CHAT_RECEPTIONIST_AVATAR_SVG_ICON"
          [src]="assistant.avatarUrl"
        ></glxy-avatar>
        <a class="name" [routerLink]="[$aiAssistantConfigUrl()]"> {{ assistant.name }}</a>
      } @else {
        <mat-icon class="avatar" svgIcon="galaxy-ai-icon" />
      }
    </div>
    <mat-chip
      disableRipple
      unselectable
      class="ai-responder-chip"
      [ngClass]="{ green: !aiResponseWaiting, gray: aiResponseWaiting }"
    >
      <div class="ai-responder-chip-content">
        @if (aiResponseWaiting) {
          {{ 'INBOX.CHAT.AI_WAITING_RESPONSE' | translate }}
          <span class="responder-countdown">{{ aiWaitTime() }}</span>
        } @else {
          {{ 'INBOX.CHAT.AI_RESPONSE_ENABLED_FOR_CONVERSATION' | translate }}
        }
        <button
          [glxyPopover]="aiResponderPopover"
          (click)="aiResponderPopover.open()"
          cdkOverlayOrigin
          #popoverOrigin="cdkOverlayOrigin"
          mat-icon-button
          class="info-button"
        >
          <mat-icon class="ai-responder-info-icon">info_outline</mat-icon>
        </button>
      </div>

      <glxy-popover
        #aiResponderPopover
        [origin]="popoverOrigin"
        [closeOnBackdropClick]="true"
        [closeOnEscapeKey]="true"
        [keepOnScreen]="true"
      >
        <div class="ai-responder-pop-over-content">
          @if (aiResponseWaiting) {
            @let conversation = (conversationDetail$ | async)?.conversation;
            <div class="ai-responder-pop-over-waiting-timer">
              <p>{{ 'INBOX.CHAT.AI_WAITING_RESPONSE' | translate }}</p>
              <p class="responder-countdown">{{ aiWaitTime() }}.</p>
              <a (click)="abortAIResponse(conversation?.conversationId || '', aiResponderPopover)">
                {{ 'INBOX.CANCEL' | translate }}</a
              >
            </div>

            {{ 'INBOX.CHAT.AI_RESPONSE_WAITING_POP_OVER' | translate: { assistantName: assistant?.name || 'AI' } }}
          } @else {
            {{ 'INBOX.CHAT.AI_RESPONSE_ACTIVE_POP_OVER' | translate: { assistantName: assistant?.name || 'AI' } }}
          }
        </div>
      </glxy-popover>
    </mat-chip>
  </div>
}

<glxy-file-drag-drop
  [uploaderTarget]="inboxUploadFile?.uploader"
  [uploadingBlocked]="isImpersonating() === true || (isOpenAIChannel$ | async) === true"
>
  <glxy-alert
    *ngIf="showDynamicFieldsHydrationAlert"
    type="warning"
    [showClose]="true"
    (close)="toggleDynamicFieldsHydrationAlert(false)"
  >
    <strong>{{ 'INBOX.MESSAGE_TEMPLATES.FIELDS_NOT_ALL_HYDRATED' | translate }}</strong>
  </glxy-alert>

  <glxy-chat-composer
    #chatComposer
    (send)="onSubmit($event)"
    [chatSources]="availableChatSources$ | async"
    [clearMessageTextOnSend]="clearMessageTextOnSend()"
    [disableSendEmptyText]="false"
    [textAreaMinRows]="disabledAlert() ? 1 : 2"
    [textAreaMaxRows]="isMobile ? 3 : 5"
    [selectedChatSourceId]="selectedChatSourceId()"
    (selectedChatSourceIdChange)="selectedChatSourceId.set($event)"
    [processing]="disableButton$ | async"
    [disabled]="isComposerDisabled()"
    [glxyPopover]="impersonatedPopover"
    (mouseenter)="isImpersonating() ? showImpersonatedPopovers() : hideImpersonatedPopovers()"
    (mouseleave)="hideImpersonatedPopovers()"
    [messageText]="messageText()"
    [enterKeySendsMessage]="!isMobile"
    [readonly]="isComposerReadonly()"
  >
    @if (showNotificationsDisabledBanner()) {
      <glxy-alert
        composerBanner
        type="tip"
        [extendedBorder]="false"
        [border]="false"
        [borderRadius]="false"
        [stackedView]="false"
        [showAction]="true"
        [actionTitle]="'INBOX.CHAT.ALLOW_PUSH_NOTIFICATIONS' | translate"
        (actionClick)="openAppSettings()"
        (close)="closeNotificationsDisabledBanner()"
        [showClose]="true"
      >
        {{ 'INBOX.CHAT.NOTIFICATIONS_DISABLED' | translate }}
      </glxy-alert>
    }

    <glxy-alert
      *ngIf="!!disabledAlert()"
      composerBanner
      type="tip"
      [showAction]="!!disabledAlert()?.action"
      [extendedBorder]="false"
      [border]="false"
      [borderRadius]="false"
      [actionTitle]="disabledAlert()?.action?.title ?? '' | translate"
      (actionClick)="!!disabledAlert()?.action?.callback()"
    >
      <span [innerHtml]="disabledAlert()?.title ?? '' | translate" class="alert-title"></span>
      @if (disabledAlert()?.title && disabledAlert()?.description) {
        &mdash;
      }
      @if (disabledAlert()?.description) {
        {{ disabledAlert()?.description || '' | translate }}
      }
    </glxy-alert>

    @if (whatsAppTemplatesAlert()) {
      <glxy-alert
        class="whatsapp-template-alert"
        composerBanner
        type="tip"
        [showAction]="false"
        [extendedBorder]="false"
        [border]="false"
        [borderRadius]="false"
        [showIcon]="false"
      >
        <div class="whatsapp-template-alert">
          @if (whatsappTemplatesService.templatesPendingApproval$ | async) {
            <span class="whatsapp-template-alert-text">
              {{ 'INBOX.CHANNEL_STATUS.WHATSAPP_MESSAGE_TEMPLATES_ONLY_BUT_PENDING_APPROVAL' | translate }}
              <a href="https://business.facebook.com/latest/whatsapp_manager"
                >https://business.facebook.com/latest/whatsapp_manager</a
              >
            </span>
          } @else {
            <span class="whatsapp-template-alert-text">
              {{ 'INBOX.CHANNEL_STATUS.WHATSAPP_MESSAGE_TEMPLATES_ONLY' | translate }}
            </span>
            <span>
              <glxy-form-field horizontalLayout size="small" bottomSpacing="none">
                <glxy-label>{{ 'INBOX.CHAT.WHATS_APP_TEMPLATE_LANGUAGE_LABEL' | translate }}</glxy-label>
                <mat-select
                  matInput
                  class="template-language-selector"
                  name="language"
                  matNativeControl
                  [(ngModel)]="whatsAppTemplateLanguage"
                >
                  @for (whatsAppTemplate of whatsAppTemplates(); track whatsAppTemplate.id) {
                    <mat-option value="{{ whatsAppTemplate.language }}">{{
                      whatsappTemplatesService.getTemplateLanguageLabel(whatsAppTemplate.language)
                    }}</mat-option>
                  }
                </mat-select>
              </glxy-form-field>
            </span>
          }
        </div>
      </glxy-alert>
    }

    <!--Composer action buttons-->
    @if (showActionButtons()) {
      <glxy-composer-actions>
        <button
          glxyComposerActionButton
          mat-icon-button
          aria-label="Show more actions"
          matTooltip="{{ 'INBOX.MORE_ACTIONS' | translate }}"
          [matMenuTriggerFor]="dynamicContentMenu"
          [hidden]="composerCollapsedActions.length === 0"
        >
          <mat-icon [inline]="true">add</mat-icon>
        </button>

        <!--Upload file && Voice recording-->
        <inbox-upload-file
          #inboxUploadFile
          [conversationDetail]="conversationDetail$ | async"
          (fileChanged)="setFile($event)"
          [enableVoiceRecording]="canAccessVoiceRecorder$ | async"
          [selectedChatSourceId]="selectedChatSourceId()"
        >
        </inbox-upload-file>
      </glxy-composer-actions>
    }
    <glxy-composer-beside-send *ngIf="showPopover$ | async" class="composer-beside-send">
      <button mat-icon-button (click)="toggleChannelInfoPopover()">
        <mat-icon cdkOverlayOrigin #popoverOrigin="cdkOverlayOrigin" class="info-icon">info_outline</mat-icon>
      </button>
      <glxy-popover
        *ngIf="popoverConfig$ | async as popoverConfig"
        [isOpen]="showChannelInfoPopover"
        [hasBackdrop]="true"
        [showBackdrop]="true"
        [hasArrow]="true"
        (backdropClick)="closeChannelInfoPopover()"
        [origin]="popoverOrigin"
      >
        <glxy-popover-title>
          {{ popoverConfig.title | translate }}
        </glxy-popover-title>
        <div>
          <p [innerHTML]="popoverConfig.contentFirst | translate"></p>
          <p>{{ popoverConfig.contentSecond | translate }}</p>
        </div>
        <glxy-popover-actions>
          <button mat-stroked-button color="primary" (click)="closeChannelInfoPopover()">
            {{ 'INBOX.CLOSE' | translate }}
          </button>
        </glxy-popover-actions>
      </glxy-popover>
    </glxy-composer-beside-send>

    <!--Popover message if a user is impersonated-->
    <glxy-popover #impersonatedPopover [isOpen]="showImpersonatedPopover" [positions]="TOOLTIP_BOTTOM_RIGHT">
      <glxy-popover-title>{{ 'INBOX.POPOVER.IMPERSONATION_TITLE' | translate }}</glxy-popover-title>
      {{ 'INBOX.POPOVER.IMPERSONATION_TEXT' | translate }}
    </glxy-popover>
  </glxy-chat-composer>

  <mat-menu #dynamicContentMenu="matMenu">
    <ng-container *ngFor="let item of composerCollapsedActions">
      <button *ngIf="item.visible | async" mat-menu-item (click)="item.onClick()" [matMenuTriggerFor]="item.matMenu">
        <mat-icon>{{ item.icon }}</mat-icon>
        <div class="menu-text">
          {{ item.action | translate }}
        </div>
      </button>
    </ng-container>
  </mat-menu>
</glxy-file-drag-drop>
